import {KTCard, KTCardBody, KTIcon} from '../../../_metronic/helpers'
import {PageTitle} from '../../../_metronic/layout/core'
import {createColumnHelper} from '@tanstack/react-table'
import ServerTable, {useServerTable} from '../../components/table/ServerTable'
import './inventory.css'
import {Link} from 'react-router-dom'
import Swal from 'sweetalert2'
import {useDeleteInventory, useGetAllInventory} from '../../hooks/inventory'
import moment from 'moment'
import {InventoryType} from '../../models/inventory'
import {ChangeEvent, useEffect, useState} from 'react'
import {Button} from 'react-bootstrap'
import { useAppContext } from '../../../_metronic/helpers/AppContext'

const InventoryPage = () => {
  const [checkedItems, setCheckedItems] = useState<{[key: number]: boolean}>({})
  const { role } = useAppContext();
  const {mutate : deleteInventory} = useDeleteInventory()
  const checkedItemsLength = Object.keys(checkedItems).filter(
    (key: any) => checkedItems[key]
  ).length
  const {
    pageIndex,
    pageSize,
    filterValue,
    sorting,
    pagination,
    setPagination,
    setSorting,
    setFiltering,
  } = useServerTable()

  const {data: inventoryList} = useGetAllInventory({
    q: filterValue,
    pageIndex,
    pageSize,
    sortBy: sorting.map((s) => `${s.id},${s.desc ? 'desc' : 'asc'}`).join(),
  })

  useEffect(() => {
    setPagination({pageIndex: 0, pageSize: 10})
  },[filterValue, setPagination])

  const handleDelete = (imei: string, id: number) => {
    Swal.fire({
      html: `
        <p>Menghapus <br> <b>Perangkat - ${imei} [IMEI] ?</b></p>
        <div style="margin-top: 10px;">
          <input type="checkbox" id="confirmCheckbox" />
          <label for="confirmCheckbox">Anda yakin menghapus perangkat ini?</label>
        </div>
      `,
      icon: 'warning',
      iconColor: '#7339eb',
      showCancelButton: true,
      confirmButtonColor: '#dc3233',
      cancelButtonColor: '#E5EAEE',
      confirmButtonText: 'Ya, Hapus!',
      cancelButtonText: 'Batalkan',
      didOpen: () => {
        const confirmButton = Swal.getConfirmButton();
        const checkbox = document.getElementById('confirmCheckbox') as HTMLInputElement;
        const cancelButton = Swal.getCancelButton();
    
        if (cancelButton) {
          cancelButton.style.color = '#686868';
        }
  
        if (confirmButton) {
          confirmButton.disabled = true;
          checkbox.addEventListener('change', () => {
            confirmButton.disabled = !checkbox.checked;
          });
        }
      },
      preConfirm: () => {
        const checkbox = document.getElementById('confirmCheckbox') as HTMLInputElement;
        if (!checkbox.checked) {
          Swal.showValidationMessage('Anda harus mencentang checkbox untuk melanjutkan.');
          return false;
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        deleteInventory({
          device_ids : [id]
        })
      }
    });
  };
  

  const handleCheck = (e: ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked
    const newCheckedItems: {[key: number]: boolean} = {}
    inventoryList?.rows.forEach((row: InventoryType) => {
      newCheckedItems[row.id] = isChecked
    })
    setCheckedItems(newCheckedItems)
  }

  const handleOneCheck = (e: ChangeEvent<HTMLInputElement>) => {
    const itemId = parseInt(e.target.value)
    const isChecked = e.target.checked
    // setChangeButtonSubmit(isChecked)
    setCheckedItems((prevState) => ({
      ...prevState,
      [itemId]: isChecked,
    }))
  }


  const handleDeleteSelection = () => {
    const device_ids = Object.keys(checkedItems).filter(
      (key: any) => checkedItems[key]
    ).map((key) => parseInt(key))
    Swal.fire({
      html: `
        <p>Menghapus semua perangkat terpilih ?</b></p>
        <div style="margin-top: 10px;">
          <input type="checkbox" id="confirmCheckbox" />
          <label for="confirmCheckbox">Anda yakin menghapus perangkat ini?</label>
        </div>
      `,
      icon: 'warning',
      iconColor: '#7339eb',
      showCancelButton: true,
      confirmButtonColor: '#dc3233',
      cancelButtonColor: '#E5EAEE',
      confirmButtonText: 'Ya, Hapus!',
      cancelButtonText: 'Batalkan',
      didOpen: () => {
        const confirmButton = Swal.getConfirmButton();
        const checkbox = document.getElementById('confirmCheckbox') as HTMLInputElement;
        const cancelButton = Swal.getCancelButton();
    
        if (cancelButton) {
          cancelButton.style.color = '#686868';
        }
  
        if (confirmButton) {
          confirmButton.disabled = true;
          checkbox.addEventListener('change', () => {
            confirmButton.disabled = !checkbox.checked;
          });
        }
      },
      preConfirm: () => {
        const checkbox = document.getElementById('confirmCheckbox') as HTMLInputElement;
        if (!checkbox.checked) {
          Swal.showValidationMessage('Anda harus mencentang checkbox untuk melanjutkan.');
          return false;
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        deleteInventory({
          device_ids 
        })
        setCheckedItems({});
      }
    });
  }

  const columnHelper = createColumnHelper<InventoryType>()
  const columns = [
    columnHelper.accessor(() => 'checkbox', {
      id: 'checkbox',
      header: () => {
        const allItemsChecked =
          inventoryList?.rows.every((row: InventoryType) => checkedItems[row.id]) ?? false
        return (
          <div className='text-center w-50'>
            <input type='checkbox' name='all' checked={allItemsChecked} onChange={handleCheck} />
          </div>
        )
      },
      cell: (info) => {
        return (
          <div className='text-center w-50'>
            <input
              value={info?.row?.original?.id}
              type='checkbox'
              name={'checkbox' + info?.row?.index}
              checked={checkedItems[info?.row?.original?.id] || false}
              onChange={handleOneCheck}
            />
          </div>
        )
      },
      enableSorting: false,
    }),
    columnHelper.accessor(() => 'itemNumber', {
      id: 'itemNumber',
      header: () => {
        return <div className='text-center w-50'>#</div>
      },
      cell: (info) => {
        return <div className='text-center w-50'>{pageSize * pageIndex + info.row.index + 1}</div>
      },
      enableSorting: false,
    }),
    columnHelper.accessor('imei', {
      id: 'imei',
      header: () => {
        return <div>IMEI</div>
      },
      cell: (info) => {
        return <div>{info?.row?.original?.imei}</div>
      },
      enableSorting: false,
    }),
    columnHelper.accessor('serial_number', {
      id: 'serial_number',
      header: () => {
        return <div>SERIAL NUMBER</div>
      },
      cell: (info) => {
        return (
          <div>{info?.row?.original?.serial_number ? info?.row?.original?.serial_number : '-'}</div>
        )
      },
      enableSorting: false,
    }),
    columnHelper.accessor('production_code', {
      id: 'production_code',
      header: () => {
        return (
          <div>
            <div>KODE PRODUKSI</div>
          </div>
        )
      },
      cell: (info) => {
        return (
          <div>
            {info?.row?.original?.production_code ? info?.row?.original?.production_code : '-'}
          </div>
        )
      },
      enableSorting: false,
    }),
    columnHelper.accessor('production_date', {
      id: 'production_date',
      header: () => {
        return <div>TANGGAL PRODUKSI</div>
      },
      cell: (info) => {
        return (
          <div>
            {info?.row?.original?.production_date
              ? moment(info?.row?.original?.production_date).format('DD MMM YYYY')
              : '-'}
          </div>
        )
      },
    }),
    columnHelper.accessor(() => 'button_control', {
      id: 'button_control',
      header: () => {
        return <div className='text-center w-50'>KONTROL</div>
      },
      cell: (info) => {
        return (
          <div className='text-center w-50'>
            <button
              type='button'
              className='btn btn-icon btn-light-danger btn-sm mx-1'
              onClick={() => handleDelete(info.row.original.imei , info.row.original.id)}
            >
              <i className='bi bi-trash fs-4'></i>
            </button>
          </div>
        )
      },
    }),
  ]

  const mode = process.env.REACT_APP_ENVIRONMENT
  if (role !== 1 || mode === "production") {
    return (
      <>
      </>
    )
  }

  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'TSM',
            path: '/inventory',
            description: '',
            isActive: true,
            isSeparator: false,
          },
        ]}
      >
        Inventory
      </PageTitle>

      <KTCard className='p-5 shadow-sm'>
        <div className='card-title d-flex justify-content-between'>
          {/* search box */}
          <div>
            <div className='card-title m-0 d-flex flex-column'>
              <div className='d-flex align-items-center position-relative my-1'>
                <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
                <input
                  type='text'
                  data-kt-user-table-filter='search'
                  className='form-control form-control-solid w-250px ps-14'
                  placeholder='Cari'
                  onChange={(e) => setFiltering(e.target.value)}
                />
              </div>
            </div>
          </div>
          {checkedItemsLength > 0 && (
            <div className='d-flex align-items-center gap-4'>
              <div className='d-flex align-items-center'>
                <p className='m-0 p-0'>{checkedItemsLength} dipilih</p>
              </div>
              <Button className='btn btn-danger me-3' onClick={() => handleDeleteSelection()}>
                Hapus Terpilih
              </Button>
            </div>
          )}

          {checkedItemsLength === 0 && (
            <div className='d-flex align-items-center'>
              <Link
                className='mx-3 btn_move color_yellow d-flex align-items-center'
                to='/inventory/move'
              >
                <KTIcon iconName='bi bi-arrow-left-right color_yellow me-2' className='fs-2' />
                Pindahkan Perangkat
              </Link>
              <Link to='/inventory/add' className='mx-3 btn btn-primary'>
                <KTIcon iconName='bi bi-plus-circle-dotted me-2' className='fs-2' />
                Tambah
              </Link>
            </div>
          )}
        </div>
        <KTCardBody>
          <ServerTable
            data={inventoryList?.rows ?? []}
            columns={columns}
            totalData={inventoryList?.total_rows ?? 0}
            pageCount={inventoryList?.total_pages ?? 0}
            pagination={pagination}
            sorting={sorting}
            setPagination={setPagination}
            setSorting={setSorting}
          />
        </KTCardBody>
      </KTCard>
    </>
  )
}

export default InventoryPage
